import useBookingNavBar from "@/hooks/booking/useBookingNavBar";
import { BookingStepperToolbar } from "./bookingStepperToolbar";

type Props = {
  buttonBackgroundColor?: string;
  buttonTextColor?: string;
  poweredByMoxie?: React.ReactNode;
};

export const MIXED_APPOINTMENT_TYPES_ERROR_MESSAGE =
  "You have selected both in person and telehealth service formats. These must be booked as separate appointments.";

export default function BookingNavBar({
  buttonBackgroundColor,
  buttonTextColor,
  poweredByMoxie,
}: Props) {
  const { visible, onContinue, continueDisabled, hasMixedAppointmentTypes } =
    useBookingNavBar();

  return (
    <>
      <BookingStepperToolbar
        visible={visible}
        hasMixedAppointmentTypes={hasMixedAppointmentTypes}
        onContinue={onContinue}
        continueDisabled={continueDisabled}
        buttonBackgroundColor={buttonBackgroundColor}
        buttonTextColor={buttonTextColor}
      />
      {poweredByMoxie}
    </>
  );
}
